
import OutlookMails from "./OutLookMails";

export default function OutlookIntegration() {
  return (
    <>
      <div className="p-3">
        <OutlookMails />
      </div>
    </>
  );
}
